/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandableItemSeparator } from "./d-theme-dark-menu-item-expandable-item-separator";

export class DThemeDarkMenuSidedItemExpandableItemSeparator extends DThemeDarkMenuItemExpandableItemSeparator {}
